export default "__VITE_ASSET__D9es1jgY__"